import { REACT_APP_CREDENTIALS, REACT_APP_LIFERAY_HOST } from "./utils";
export const BASE_URL =REACT_APP_LIFERAY_HOST || window.location.origin; // Same domain in production
const adminUserHeader = {
  "Content-Type": "application/json",
  Authorization: "Basic " + btoa(REACT_APP_CREDENTIALS),
}

const headers = window.Liferay
  ? {
    "Content-Type": "application/json",
    "x-csrf-token": window.Liferay.authToken,
  }
  : {
    "Content-Type": "application/json",
    Authorization: "Basic " + btoa(REACT_APP_CREDENTIALS),
  };

const postFileHeaders = {
  Authorization: "Basic " + btoa(REACT_APP_CREDENTIALS),
  Accept: "application/json",
};

const LiferayService = {
  get: (url, options = {}, userConnected = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: userConnected ? headers : adminUserHeader,
          method: "GET",
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  post: (url, payload, options = {}, userConnected = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: userConnected ? headers : adminUserHeader,
          method: "POST",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  postFile: (url, formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: postFileHeaders,
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  put: (url, payload, options = {}, userConnected = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: userConnected ? headers : adminUserHeader,
          method: "PUT",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  patch: (url, payload, options = {}, userConnected = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: userConnected ? headers : adminUserHeader,
          method: "PATCH",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  delete: (url, userConnected = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(BASE_URL + "/" + url, {
          headers: userConnected ? headers : adminUserHeader,
          method: "DELETE",
        });

        if (response.ok) {
          resolve(true);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export default LiferayService;
